export { CueRowDisplay } from './CueRowDisplay'
export type { CueRowDisplayProps } from './CueRowDisplay'
export { ScriptBookByScene } from './ScriptBookByScene'
export type { ScriptBookBySceneProps, ScriptBookByScenePropsRow } from './ScriptBookByScene'
export { ScriptBookByCharacter } from './ScriptBookByCharacter'
export type { ScriptBookByCharacterProps } from './ScriptBookByCharacter'
export { ExportButtons } from './ExportButtons'
export type { ExportButtonsProps } from './ExportButtons'

import type { CharacterRow } from '../../lib/api/producer-types'

/**
 * Stable color palette for the character badges across both views. Up to 16
 * colors; rolls over for projects with more characters.
 */
const PALETTE = [
  '#3b82f6',
  '#10b981',
  '#f59e0b',
  '#ef4444',
  '#8b5cf6',
  '#ec4899',
  '#14b8a6',
  '#84cc16',
  '#f97316',
  '#06b6d4',
  '#a855f7',
  '#22c55e',
  '#eab308',
  '#0ea5e9',
  '#d946ef',
  '#64748b',
] as const

export function buildCharacterColorMap(characters: CharacterRow[]): Map<string, string> {
  const map = new Map<string, string>()
  characters.forEach((c, i) => {
    map.set(c.id, PALETTE[i % PALETTE.length] ?? '#64748b')
  })
  return map
}
